// @ts-check

const createScript = id => {
    const $fragment = document.createDocumentFragment();

    const $script = document.createElement("script");
    $script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
    $script.async = true;

    const $code = document.createElement("script");

    $code.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());

        gtag('config', '${id}');
    `;

    $fragment.appendChild($script);
    $fragment.appendChild($code);

    return $fragment;
};

export default createScript;
